import React from 'react';
import { TabState } from '../../../../types';
import * as styles from '../../../tab-system/TabContainer.css.ts';

interface HelpTabContentProps {
  tab: TabState;
}

export const HelpTabContent: React.FC<HelpTabContentProps> = ({ tab: _tab }) => {
  return (
    <div data-testid="help-content" className={styles.tabContentScrollable}>
      <div className={styles.helpTabContent}>
        <h2>MIDAS - Help</h2>

        <div className={styles.helpSection}>
          <p>Help documentation is under construction.</p>
          <p>For now, please explore the interface to discover features.</p>
        </div>
      </div>
    </div>
  );
};